/* ==========================================================================
   FLC Forge — Tabs
   ========================================================================== */

class FLCTabs extends HTMLElement {
  connectedCallback() {
    this.tabList  = this.querySelector('[role="tablist"]');
    this.tabs     = this.querySelectorAll('[role="tab"]');
    this.panels   = this.querySelectorAll('[role="tabpanel"]');

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.selectTab(i));
      tab.addEventListener('keydown', (e) => this.onKeyDown(e, i));
    });

    // Activate first tab if none selected
    if (![...this.tabs].some(t => t.getAttribute('aria-selected') === 'true')) {
      this.selectTab(0);
    }
  }

  selectTab(index) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', active);
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });

    this.panels.forEach((panel, i) => {
      const isActive = i === index;
      if (isActive) {
        panel.removeAttribute('hidden');
        panel.classList.add('tabs__panel--entering');
        requestAnimationFrame(() => {
          requestAnimationFrame(() => panel.classList.remove('tabs__panel--entering'));
        });
      } else {
        panel.classList.remove('tabs__panel--entering');
        panel.setAttribute('hidden', '');
      }
    });

    this.tabs[index]?.focus();
  }

  onKeyDown(e, currentIdx) {
    let nextIdx;
    if (e.key === 'ArrowRight') nextIdx = (currentIdx + 1) % this.tabs.length;
    if (e.key === 'ArrowLeft')  nextIdx = (currentIdx - 1 + this.tabs.length) % this.tabs.length;
    if (e.key === 'Home')       nextIdx = 0;
    if (e.key === 'End')        nextIdx = this.tabs.length - 1;

    if (nextIdx !== undefined) {
      e.preventDefault();
      this.selectTab(nextIdx);
    }
  }
}

customElements.define('flc-tabs', FLCTabs);
